import { firestore } from "firebase";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    listMilestone: []
  },
  actions: {
    saveMilestone({ state }) {
      const projectID = router.currentRoute.params.project_id;
      const storageRefMilestone = firestore()
        .collection(`Project`)
        .doc(projectID);
      storageRefMilestone
        .set({ milestones: state.listMilestone }, { merge: true })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Los datos fueron guardados");
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("No se guardo el milestone");
        });
    }
  },
  mutations: {
    INSERT_MILESTONE: (state, milestone) => {
      state.listMilestone.push(milestone);
    },
    SAVE_MILESTONE: (state, milestone) => {
      if (Array.isArray(milestone)) {
        state.listMilestone = milestone;
      } else {
        state.listMilestone = [];
      }
    },
    DELETE_MILESTONE: (state, description) => {
      state.listMilestone = state.listMilestone.filter(
        item => item.description !== description
      );
    }
  },
  getters: {}
};
